import {
   AfterViewInit,
   ChangeDetectionStrategy,
   Component,
   EventEmitter,
   Input,
   OnDestroy,
   Output,
   ViewEncapsulation,
} from '@angular/core';
import { CallState } from '@lcs/shared/api';
import { Store } from '@ngrx/store';
import { interval, Subject } from 'rxjs';
import { filter, takeUntil, withLatestFrom } from 'rxjs/operators';
import { getIsLoggedIn } from 'src/app/authentication/state/authentication.selector';
import { DashboardTile } from 'src/app/pages/dashboard/models/dashboard-tile.model';

@Component({
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-tile-view',
    templateUrl: './tile-view.component.html',
    styleUrls: ['./tile-view.component.scss'],
    standalone: false
})
export class TileViewComponent implements AfterViewInit, OnDestroy {
   @Input('tileConfig') tileConfig: DashboardTile;

   @Input('isFullscreen') isFullscreen: boolean = false;

   @Input('isEditing') isEditing: boolean = false;

   @Input('showHeader') showHeader: boolean = true;

   @Input('canRefresh') canRefresh: boolean = true;

   @Input('overrideRefreshTile') overrideRefreshTile: boolean = false;

   @Input() callState: CallState | undefined;

   @Output() configureParameters = new EventEmitter<void>();

   @Output() openFullscreen = new EventEmitter<void>();

   @Output() closeFullscreen = new EventEmitter<void>();

   @Output() deleteTile = new EventEmitter<number>();

   @Output() refreshTile = new EventEmitter<void>();

   private readonly destroyed$ = new Subject<void>();

   constructor(private readonly store: Store) {}

   ngAfterViewInit(): void {
      if (this.tileConfig.dashboardTileLayoutConfiguration.refreshTimeSeconds) {
         interval(this.tileConfig.dashboardTileLayoutConfiguration.refreshTimeSeconds * 1000)
            .pipe(
               withLatestFrom(this.store.select(getIsLoggedIn)),
               filter(([, isLoggedIn]) => isLoggedIn && !this.overrideRefreshTile),
               takeUntil(this.destroyed$)
            )
            .subscribe(() => this.onRefreshTile());
      }
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
      this.destroyed$.complete();
   }

   onConfigureParameters() {
      this.configureParameters.emit();
   }

   onOpenFullscreen() {
      this.openFullscreen.emit();
   }

   onCloseFullscreen() {
      this.closeFullscreen.emit();
   }

   onDeleteTile() {
      this.deleteTile.emit(this.tileConfig.dashboardTileId);
   }

   onRefreshTile() {
      this.refreshTile.emit();
   }
}
